<!-- <dojo-challenge-activity-question-selector question-selector /> -->
<dojo-question
  [isTransitioningBetweenQuestions]="isTransitioningBetweenQuestions()"
  [shouldShowRightSidebar]="state.shouldShowRightSidebar"
  [sidebarTemplateRef]="questionSelectorTemplate"
  [footerTemplateRef]="footerTemplate"
  [loadingTemplateRef]="loadingTemplate"
  (completed)="onQuestionCompleted('stop')"
/>
<ng-template #questionSelectorTemplate>
  <div class="bg-neutral-0 flex flex-col gap-2 border-b border-neutral-200 md:h-full md:border-b-0 md:border-r">
    <dojo-challenge-activity-question-selector class="flex-1" />

    @if (state.shouldShowSubmitButton) {
      <wide-layout>
        <div class="flex-shrink-0 border-t border-neutral-200 px-2 py-3">
          <dojo-button [fill]="'clear'" (click)="gradeChallengeActivity()" [customColor]="'sky'">
            <dojo-icon [icon]="'paper-plane'" [size]="18"></dojo-icon>
            <span class="ml-3 text-sm">{{ 'exams.submit' | transloco }}</span>
          </dojo-button>
          <dojo-exam-time class="mt-1" />
        </div>
      </wide-layout>
    }
  </div>
</ng-template>
<!-- @if (state.isNewQuestionLayoutEnabled) {
  <dojo-question />
} @else {
  <dojo-question-old />
} -->

<ng-template #footerTemplate>
  <small-layout>
    <dojo-footer-panel>
      <div class="right item-center flex flex-row justify-end gap-2">
        @if (state.challengeActivityStatus !== 'IN_PROGRESS') {
          <dojo-button
            [disabled]="state.challengeActivityStatus === 'SUBMITTED'"
            fill="solid"
            (click)="onQuestionCompleted('complete')"
            [ngClass]="
              state.isQuestionMultipleChoice ? 'small:w-auto mr-[96px] block w-full' : 'w-full md:min-w-[178px]'
            "
          >
            {{ 'challenge.finish' | transloco }}
          </dojo-button>
        } @else {
          <dojo-button
            [fill]="state.allQuestionAttemptsDone || state.isTimeUp ? 'solid' : 'outline'"
            (click)="gradeChallengeActivity()"
            [ngClass]="
              state.isQuestionMultipleChoice ? 'small:w-auto mr-[96px] block w-full' : 'w-full md:min-w-[178px]'
            "
          >
            {{ 'challenge.finish_and_submit' | transloco }}
          </dojo-button>
        }
        <wide-layout>
          <dojo-button
            fill="outline"
            (click)="onQuestionCompleted('stop')"
            [customColor]="'red'"
            class="w-full md:min-w-[178px]"
          >
            {{ 'exams.end' | transloco }}
          </dojo-button>
        </wide-layout>
      </div>
    </dojo-footer-panel>
  </small-layout>
  <wide-layout>
    <dojo-footer-panel [limitWidthContainer]="false">
      <div left>
        <dojo-button
          fill="outline"
          (click)="onQuestionCompleted('stop')"
          [customColor]="'red'"
          class="w-full md:min-w-[178px]"
        >
          {{ 'exams.end' | transloco }}
        </dojo-button>
      </div>
      <div right class="flex items-center justify-end gap-2">
        @if (state.challengeActivityStatus !== 'IN_PROGRESS') {
          <dojo-button
            [disabled]="state.challengeActivityStatus === 'SUBMITTED'"
            fill="solid"
            (click)="onQuestionCompleted('complete')"
            class="w-full md:min-w-[178px]"
          >
            {{ 'challenge.finish' | transloco }}
          </dojo-button>
        } @else {
          <dojo-button
            [fill]="state.allQuestionAttemptsDone || state.isTimeUp ? 'solid' : 'outline'"
            (click)="gradeChallengeActivity()"
            class="w-full md:min-w-[178px]"
          >
            {{ 'challenge.finish_and_submit' | transloco }}
          </dojo-button>
        }
      </div>
    </dojo-footer-panel>
  </wide-layout>
</ng-template>

<ng-template #loadingTemplate>
  <dojo-challenge-grading-loading />
</ng-template>
